export default "__VITE_ASSET__COwmC$t2__"